import React from "react";
import { TextField, Grid, Typography, Divider } from "@mui/material";

const BrokerForm = ({ newBroker, handleChange, errors }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" color="text.secondary">
          Login account (required for broker portal access)
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          autoFocus
          margin="dense"
          label="Username"
          type="text"
          fullWidth
          required
          name="username"
          value={newBroker.username}
          onChange={handleChange}
          error={Boolean(errors.username)}
          helperText={errors.username}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          label="Password"
          type="password"
          fullWidth
          required
          name="password"
          value={newBroker.password}
          onChange={handleChange}
          error={Boolean(errors.password)}
          helperText={errors.password}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          label="First name"
          type="text"
          fullWidth
          required
          name="first_name"
          value={newBroker.first_name}
          onChange={handleChange}
          error={Boolean(errors.first_name)}
          helperText={errors.first_name}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          label="Last name"
          type="text"
          fullWidth
          required
          name="last_name"
          value={newBroker.last_name}
          onChange={handleChange}
          error={Boolean(errors.last_name)}
          helperText={errors.last_name}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          label="Email"
          type="email"
          fullWidth
          name="email"
          value={newBroker.email}
          onChange={handleChange}
          error={Boolean(errors.email)}
          helperText={errors.email}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          label="Phone number"
          type="text"
          fullWidth
          required
          name="phone_number"
          value={newBroker.phone_number}
          onChange={handleChange}
          error={Boolean(errors.phone_number)}
          helperText={errors.phone_number || "Used for login and broker contact — e.g. 0751234567 or +256777222333"}
        />
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2" color="text.secondary">
          Broker profile
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <TextField
          margin="dense"
          label="Broker display name"
          type="text"
          fullWidth
          required
          name="broker_name"
          value={newBroker.broker_name}
          onChange={handleChange}
          error={Boolean(errors.broker_name)}
          helperText={errors.broker_name}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          label="Location"
          type="text"
          fullWidth
          required
          name="broker_location"
          value={newBroker.broker_location}
          onChange={handleChange}
          error={Boolean(errors.broker_location)}
          helperText={errors.broker_location}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          margin="dense"
          label="National Identification Number (NIN)"
          type="text"
          fullWidth
          name="broker_nin"
          value={newBroker.broker_nin}
          onChange={handleChange}
          error={Boolean(errors.broker_nin)}
          helperText={errors.broker_nin || "Optional"}
        />
      </Grid>
    </Grid>
  );
};

export default BrokerForm;
